// US state code → full name. Stored values are 2-letter codes (matches parcels.state);
// UI selectors display the full name. Used by Assessors & Collectors (Phase A) and onward.
export const US_STATES = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
  FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois',
  IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
  ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
  MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
  NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
  NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon',
  PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota',
  TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia',
  WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
};

// Full name for a code, falling back to the raw code if unknown.
export const stateName = (code) => US_STATES[code] || code || '—';

// Normalize any state input to the app's canonical 2-letter UPPERCASE code.
// Full name → code (case-insensitive, "Alabama"→"AL"), valid 2-letter code passes through,
// anything unrecognized → null (caller decides what a bad state means). The stored column is
// strict 2-letter codes, so raw AI/sheet values ("Alabama","Ala","al") MUST pass through here
// before any .eq('state', …) — an un-normalized value silently matches zero rows.
const _norm = (s) => String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim();
const _NAME_TO_CODE = Object.entries(US_STATES).reduce((m, [code, name]) => { m[_norm(name)] = code; return m; }, {});
const _VALID_CODES = new Set(Object.keys(US_STATES));
export const toStateCode = (v) => {
  if (v == null) return null;
  const s = String(v).trim(); if (!s) return null;
  const up = s.toUpperCase();
  if (_VALID_CODES.has(up)) return up;        // already a 2-letter code
  return _NAME_TO_CODE[_norm(s)] || null;     // full name → code; unknown → null
};
